import { WhiteSpaceStyled } from './styles';

export default ({ height, width }) => {
  return <WhiteSpaceStyled height={height} width={width} />;
};
